import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Typography from '@material-ui/core/Typography';
import Dialog from '@afosto/app-components-react/Dialog';
import Icon from '@afosto/app-components-react/Icon';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import translations from './translations';

const CheckParcelsDialog = ({ isLoading, isOpen, onContinue, onCreate, onDelete, parcels }) => {
  const intl = useIntl();

  const handleCreateParcel = () => {
    if (onCreate && typeof onCreate === 'function') {
      onCreate();
    }
  };

  const handleDeleteParcel = parcel => () => {
    if (onDelete && typeof onDelete === 'function') {
      onDelete(parcel);
    }
  };

  return (
    <Dialog open={isOpen} maxWidth="xs" disableRestoreFocus>
      <DialogTitle>
        <FormattedMessage {...translations.title} />
      </DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        <LoadingWrapper isLoading={isLoading}>
          {parcels.length > 0 && (
            <List style={{ minWidth: 300 }}>
              <Divider />
              {parcels.map(parcel => (
                <ListItem key={parcel.id} divider>
                  <ListItemText
                    primary={parcel.number}
                    secondary={intl.formatMessage(translations.numberOfItems, {
                      count: parcel.count ?? 0,
                    })}
                  />
                  {parcel?.count === 0 && (
                    <ListItemSecondaryAction>
                      <IconButton
                        color="secondary"
                        edge="end"
                        aria-label="delete"
                        onClick={handleDeleteParcel(parcel)}
                      >
                        <Icon icon={['fal', 'trash']} />
                      </IconButton>
                    </ListItemSecondaryAction>
                  )}
                </ListItem>
              ))}
            </List>
          )}
          {!parcels?.length && (
            <Box px={3} py={2}>
              <FormattedMessage {...translations.emptyMessage} />
            </Box>
          )}
        </LoadingWrapper>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
        <Box width="100%">
          <Box my={2}>
            <Typography variant="body1">
              <FormattedMessage
                {...translations.numberOfParcels}
                values={{ count: parcels?.length ?? 0 }}
              />
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Button
              color="primary"
              variant="outlined"
              onClick={handleCreateParcel}
              disabled={isLoading}
            >
              <FormattedMessage {...translations.buttons.newParcel} />
            </Button>
            <Button color="primary" variant="contained" onClick={onContinue} disabled={isLoading}>
              <FormattedMessage {...translations.buttons.continue} />
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

CheckParcelsDialog.propTypes = {
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  onContinue: PropTypes.func,
  onCreate: PropTypes.func,
  onDelete: PropTypes.func,
  parcels: PropTypes.array,
};

CheckParcelsDialog.defaultProps = {
  isLoading: false,
  isOpen: false,
  onContinue: undefined,
  onCreate: undefined,
  onDelete: undefined,
  parcels: [],
};

export default CheckParcelsDialog;
